import React, { useState } from "react";
import fallBackImg from "../assets/nestfin/No_image_Found.png";
import {CustomLoaderSmall } from "../components/CustomLoader";

type Props = {
  src: string;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
};

export const ImageWithLoader: React.FC<Props> = ({ src, alt, className, style }) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
        ...style,
      }}
      className={className}
    >
      {/* Loader Skeleton */}
      {!loaded && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "#e6e6e6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "14px",
          }}
        >
          <CustomLoaderSmall/>
        </div>
      )}

      <img
        src={error ? fallBackImg : src}
        alt={alt || "image"}
        onLoad={() => setLoaded(true)}
        onError={() => {
          setError(true);
          setLoaded(true);
        }}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          transition: "opacity 0.3s ease-in-out",
          opacity: loaded ? 1 : 0,
        }}
      />
    </div>
  );
};
